import React from "react";
import { View } from "react-native";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";
import { uniqueId } from "lodash";

export default function LightBulbIcon(props) {
  const color = props.color || "#FFF";
  const filterId = "clip0" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";

  return (
    <View style={props.style} {...props}>
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
          <G clipPath={filterUrl}>
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.27767 1.33301H10.7221V3.49967H9.27767V1.33301ZM4.38172 3.36063L3.36035 4.382L4.8924 5.91405L5.91377 4.89268L4.38172 3.36063ZM4.89258 10.1544C4.89258 7.34548 7.19079 5.04727 9.99972 5.04727C12.8087 5.04727 15.1069 7.34548 15.1069 10.1544C15.1069 12.027 14.0854 13.6443 12.5533 14.5806V17.8151C12.5533 18.3258 12.2128 18.6663 11.7021 18.6663H8.29734C7.78663 18.6663 7.44615 18.3258 7.44615 17.8151V14.5806C5.91401 13.6443 4.89258 12.027 4.89258 10.1544ZM9.14853 16.1127V16.9639H10.8509V16.1127H9.14853ZM10.8509 14.0699C10.8509 13.7294 11.0212 13.3889 11.3616 13.3038C12.6384 12.708 13.4045 11.5163 13.4045 10.1544C13.4045 8.28179 11.8723 6.74965 9.99972 6.74965C8.1271 6.74965 6.59496 8.28179 6.59496 10.1544C6.59496 11.5163 7.36103 12.708 8.63782 13.3038C8.97829 13.3889 9.14853 13.7294 9.14853 14.0699V15.2616H10.8509V14.0699ZM1.33301 9.27756H3.49967V10.722H1.33301V9.27756ZM15.6173 3.36049L14.0853 4.89254L15.1067 5.9139L16.6387 4.38185L15.6173 3.36049ZM16.4997 9.27756H18.6663V10.722H16.4997V9.27756Z"
              fill={color}
            />
          </G>
          <Defs>
            <ClipPath id={filterId}>
              <Rect
                width="17.3333"
                height="17.3333"
                fill={color}
                transform="translate(1.33325 1.33301)"
              />
            </ClipPath>
          </Defs>
      </Svg>
    </View>
  );
}
